import * as angular from 'angular';

import { helpUrlsLookup } from './help-urls.constant';

export const helpUrlsModule = angular.module('helpUrls', [])
	.constant('helpUrls', helpUrlsLookup)
	.name;
